export enum InitialFolderStateMode {
    Default = 0,
    All = 1,
    NewMatches = 2,
    Appointments = 3,
    Comments = 4,
    Liked = 5
}